<template>
    <div id="header_alert_component" v-if="show">
        <div class="header-alert--inside">
            <div v-html="message"></div>
            <div class="text-center" style="margin-top: 12px;">
                <button class="button--cancel-white" @click="confirm()">OK</button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['cookie', 'message'],
        data: () => {
            return {
                show: false
            }
        },
        methods: {
            confirm: function() {
                this.$cookie.set(this.cookie, true);
                this.show = false;
            }
        },
        created(){
            const cookie = this.$cookie.get(this.cookie);
            if (!cookie) {
                this.show = true;
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../../../../assets/scss/_colors.scss';

    .header-alert--inside {
        display: block;
        padding: 6px 15px;
        margin: 30px 0 0;
        background-color: $red;
        transition: 200ms all linear;

        .button--cancel-white{
            padding: 5px 26px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/layout/partials/header/middlebar/HeaderCookieMessage.vue